var flipflops = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-obj/flipflops_gd.jpg';
var floatingbeachball = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-obj/floatingbeachball_gd.jpg';
var chocolatedips = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-obj/chocolatedips_gd.jpg';
var chinesetakeout = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-obj/chinesetakeout_gd.jpg';
var cakes = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-obj/cakes_gd.jpg';
var petitfours = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-obj/petitfours_gd.jpg';
var shoebag = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-obj/shoebag_gd.jpg';

export const allImagesDesktopOrderPaperObj = [
    [/*COLUMN 1*/
        [
            {
                name: flipflops,
                artistName: "Lorraine Shemesh",
                title: "Flip Flops",
                year: "1986",
                dimensions: "30 x 22 in., graphite",
                link: "paperobj1",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: chocolatedips,
                artistName: "Lorraine Shemesh",
                title: "Chocolate Dips",
                year: "1984",
                dimensions: "30 x 22 in., graphite",
                link: "paperobj3",
                privateCollection: "Private Collection"
            }
        ]
    ],
    [/*COLUMN 2*/
        [
            {
                name: floatingbeachball,
                artistName: "Lorraine Shemesh",
                title: "Floating Beach Ball",
                year: "1987",
                dimensions: "30 x 30 in., graphite",
                link: "paperobj2",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: petitfours,
                artistName: "Lorraine Shemesh",
                title: "Petit-Fours",
                year: "1984",
                dimensions: "30 x 22 in., graphite",
                link: "paperobj6",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: cakes,
                artistName: "Lorraine Shemesh",
                title: "Cakes",
                year: "1988",
                dimensions: "39 x 43 in., graphite",
                link: "paperobj5",
                privateCollection: "Private Collection"
            }
        ]
    ],
    [/*COLUMN 3*/
        [
            {    
                name: chinesetakeout,
                artistName: "Lorraine Shemesh",
                title: "Chinese Take Out",
                year: "1987",
                dimensions: "30 x 32 in., graphite",
                link: "paperobj4",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: shoebag,
                artistName: "Lorraine Shemesh",
                title: "Shoe Bag",
                year: "1981",
                dimensions: "30 x 22 in., graphite",
                link: "paperobj7",
                privateCollection: "Private Collection"
            }
        ]
    ]          
]

export const allImagesMobileOrderPaperObj = [
    [{
        name: flipflops,
        artistName: "Lorraine Shemesh",
        title: "Flip Flops",
        year: "1986",
        dimensions: "30 x 22 in., graphite",
        link: "paperobj1",
        privateCollection: "Private Collection"
    },
    {
        name: floatingbeachball,
        artistName: "Lorraine Shemesh",
        title: "Floating Beach Ball",
        year: "1987",
        dimensions: "30 x 30 in., graphite",
        link: "paperobj2",
        privateCollection: "Private Collection"
    },
    {
        name: chocolatedips,
        artistName: "Lorraine Shemesh",
        title: "Chocolate Dips",
        year: "1984",
        dimensions: "30 x 22 in., graphite",
        link: "paperobj3",
        privateCollection: "Private Collection"
    },
    {
        name: chinesetakeout,
        artistName: "Lorraine Shemesh",
        title: "Chinese Take Out",
        year: "1987",
        dimensions: "30 x 32 in., graphite",
        link: "paperobj4",
        privateCollection: "Private Collection"
    },
    {
        name: cakes,
        artistName: "Lorraine Shemesh",
        title: "Cakes",
        year: "1988",
        dimensions: "39 x 43 in., graphite",
        link: "paperobj5",
        privateCollection: "Private Collection"
    },
    {
        name: petitfours,
        artistName: "Lorraine Shemesh",
        title: "Petit-Fours",
        year: "1984",
        dimensions: "30 x 22 in., graphite",
        link: "paperobj6",
        privateCollection: "Private Collection"
    },
    {
        name: shoebag,
        artistName: "Lorraine Shemesh",
        title: "Shoe Bag",
        year: "1981",
        dimensions: "30 x 22 in., graphite",
        link: "paperobj7",
        privateCollection: "Private Collection"
    }]      
]
